module.exports = __webpack_public_path__ + "assets/img/btn-detail-57a50a11.png";